import styles from './Button.scss';

import cx from 'classnames';
import React, { forwardRef } from 'react';

import { LinkVariant } from 'src/api/contentful/contentTypes.cloverdotcom';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: LinkVariant;
  isFullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      style,
      variant,
      isFullWidth,
      children,
      ...props
    }, ref) => {
    const buttonClassName = cx({
      [styles.buttonVariantPrimary]: variant === LinkVariant.PRIMARY,
      [styles.buttonVariantSecondary]: variant === LinkVariant.SECONDARY,
      [styles.buttonVariantText]: variant === LinkVariant.TEXT,
      [styles.buttonFullWidth]: isFullWidth,
    }, styles.button, className);

    const dataTest = props.id === null ? 'button' : `${props.id?.toString()}-button`;
    if (!children) return null;

    return (
      <button
        className={buttonClassName}
        style={style}
        data-test={dataTest}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';
